import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getWords',
})
export class GetWordsPipe implements PipeTransform {
  transform(data: string, count: number = 2): any {
    return data.split(' ').slice(0, count).join(' ').replace(/,/g, '');
  }
}
